<template>
  <Breadcrumbs />
  <BlogPostGrid class="mb-4" />
</template>

<style lang="scss" scoped></style>
